import React from "react";
import { Content } from "antd/lib/layout/layout";
import { Switch, Route, Redirect } from "react-router-dom";

import "./index.css";
import Dashboard from "../../screens/Dashboard";
import User from "../../screens/Users";
import Staff from "../../screens/Staff";
import Packages from "../../screens/Packages";
import Offers from "../../screens/Offers";
import Orders from "../../screens/Orders";
import Products from "../../screens/Products";
import Reports from "../../screens/Reports";
import Payments from "../../screens/Payments";
import Settings from "../../screens/Settings";
import Delivery from "../../screens/Delivery";
import PaymentMethods from "../../screens/PaymentMethods";
import InstoreMusic from "../../screens/InstoreMusic";
import ShelfTalker from "../../screens/ShelfTalker";
import TemplateBuilder from "../../screens/TemplateBuilder";
import StoreChecklists from "../../screens/StoreChecklists";
import StockUpload from "../../screens/StockUpload";
import { canViewSection, getUserRole, ROLES } from "../../helpers/permissions";
import { isOperationsOnlyRole } from "../../helpers/permissions";

export default function SidenavRoutes({
  contentWidth = 200,
  logoClicked = false,
}) {
  // Workers and unassigned Operations staff only get Store Checklists.
  if (isOperationsOnlyRole()) {
    return (
      <Content style={{ marginLeft: contentWidth }} className="cnt">
        <Switch>
          <Route path="/store-checklists">
            <StoreChecklists />
          </Route>
          <Route path="/">
            <Redirect to="/store-checklists" />
          </Route>
        </Switch>
      </Content>
    );
  }

  // Get default page based on role
  const getDefaultPage = () => {
    const role = getUserRole();

    // Role-specific default pages
    if (role === ROLES.SUPERADMIN || role === ROLES.ADMIN) {
      return "/dashboard";
    } else if (role === ROLES.MARKETING) {
      return "/shelf-talker";
    } else if (role === ROLES.STORE_MANAGER) {
      return "/products";
    }

    // Fallback logic
    if (canViewSection("dashboard")) {
      return "/dashboard";
    } else if (canViewSection("products")) {
      return "/products";
    } else if (canViewSection("shelf-talker")) {
      return "/shelf-talker";
    }
    return "/dashboard"; // final fallback
  };

  return (
    <Content style={{ marginLeft: contentWidth }} className="cnt">
      <Switch>
        {logoClicked && (
          <Route path="/">
            <Redirect to={getDefaultPage()} />
          </Route>
        )}
        {canViewSection("dashboard") && (
          <Route path="/dashboard">
            <Dashboard />
          </Route>
        )}
        <Route path="/users">
          <User />
        </Route>
        <Route path="/staff">
          <Staff />
        </Route>
        <Route path="/packages">
          <Packages />
        </Route>
        <Route path="/orders">
          <Orders />
        </Route>
        <Route path="/delivery">
          <Delivery />
        </Route>
        <Route path="/payments">
          <Payments />
        </Route>
        <Route path="/payment-methods">
          <PaymentMethods />
        </Route>
        <Route path="/products">
          <Products />
        </Route>
        <Route path="/promotions">
          <Offers />
        </Route>
        <Route path="/settings">
          <Settings />
        </Route>
        <Route path="/reports">
          <Reports />
        </Route>
        <Route path="/instore-music">
          <InstoreMusic />
        </Route>
        <Route path="/shelf-talker">
          <ShelfTalker />
        </Route>
        <Route path="/template-builder">
          <TemplateBuilder />
        </Route>
        {canViewSection("store-checklists") && (
          <Route path="/store-checklists">
            <StoreChecklists />
          </Route>
        )}
        {canViewSection("stock-upload") && (
          <Route path="/stock-upload">
            <StockUpload />
          </Route>
        )}
        <Route path="/">
          <Redirect to={getDefaultPage()} />
        </Route>
      </Switch>
    </Content>
  );
}
